/**
 * Normalizes a locale identifier to the BCP-47 hyphen form the backend's
 * `LocaleIdentifier` validation accepts (pattern `^[a-z]{2,3}(-[A-Z0-9]{2,3}){0,1}$`).
 *
 * The only transformation is swapping the legacy underscore separator for a
 * hyphen (`en_US` → `en-US`); the language/region subtags are left untouched.
 * `SubmitStringGroupTranslation` rejects the underscore form, so every locale
 * that reaches a submit payload must pass through here first.
 *
 * Applied at the submit boundary (see `useSubmitTranslation` and
 * `RollbackModal`) so all submit paths emit a consistent, valid form
 * regardless of where the value originated (server data, create-modal
 * metadata, or a legacy underscore value). Production data is already hyphen
 * form; this is defense-in-depth against a stray underscore separator.
 */
export function normalizeLocaleIdentifier(locale: string): string {
  return locale.replace(/_/g, '-');
}
